import { useId, useState } from 'react'
import { Input, Text } from '../../../components'
import { resolveQrAccentColor } from '../../../qr-theme'
import { QR_ACCENT_COLOR } from '../../../config'
import editColorIcon from '../../../assets/icons/edit-color-icon.svg'

interface AccentColorPickerProps {
    initialColor?: string | null;
    onChange: (value: string) => void;
}

// Черновик сохраняется родительской формой при нажатии «Сохранить».
export const AccentColorPicker = ({initialColor, onChange}: AccentColorPickerProps) => {
    const id = useId()
    const [color, setColor] = useState(() => resolveQrAccentColor(initialColor))
    const [hex, setHex] = useState(() => resolveQrAccentColor(initialColor).toUpperCase())
    const [showError, setShowError] = useState(false)
    const isDefaultColor = hex.trim().replace(/^#/, '').toUpperCase() === QR_ACCENT_COLOR.slice(1).toUpperCase()

    const changeHex = (value: string) => {
        setHex(value)
        onChange(value)
        setShowError(false)
        const match = /^#?([0-9a-f]{6})$/i.exec(value.trim())
        if (match) setColor(`#${match[1]}`)
    }

    return (
        <div className="admin-accent-picker">
            <div className="admin-accent-heading">
                <Text size="xs" color="lightGray">Акцентный цвет</Text>
                {!isDefaultColor && (
                    <button
                        type="button"
                        className="admin-accent-reset"
                        onClick={() => changeHex(QR_ACCENT_COLOR.toUpperCase())}
                    >
                        Сбросить
                    </button>
                )}
            </div>
            <div className="admin-accent-controls">
                <label className="admin-accent-swatch" title="Открыть палитру" style={{backgroundColor: color}}>
                    <input
                        type="color"
                        value={color}
                        aria-label="Открыть палитру акцентного цвета"
                        onChange={(event) => {
                            setColor(event.target.value)
                            onChange(event.target.value)
                            setHex(event.target.value.toUpperCase())
                            setShowError(false)
                        }}
                    />
                    <img src={editColorIcon} width="24" height="24" alt="" />
                </label>
                <Input
                    id={id}
                    aria-label="Акцентный цвет в формате HEX"
                    placeholder="#A8E10C"
                    value={hex}
                    onChange={(event) => changeHex(event.target.value)}
                    onBlur={() => setShowError(!/^#?[0-9a-f]{6}$/i.test(hex.trim()))}
                    error={showError ? 'Введите HEX-код из 6 символов, например #A8E10C' : undefined}
                    maxLength={7}
                    autoComplete="off"
                    spellCheck={false}
                />
            </div>
        </div>
    )
}
